import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

/** 高さ 44px 以上を確保し、必ず文字ラベルを持つボタン。 */
export function Button({ variant = 'primary', className = '', children, ...rest }: Props) {
  const base =
    'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-ln px-5 text-[15px] font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-50';

  const variants: Record<Variant, string> = {
    primary: 'bg-brand text-white hover:bg-brand-hover active:bg-brand-active',
    secondary: 'border border-line bg-white text-ink-muted hover:bg-surface-muted',
    ghost: 'text-brand hover:bg-brand-subtle',
  };

  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...rest}>
      {children}
    </button>
  );
}
